import ButtonActionIcon from "../../../../components/BuilderComponents/ButtonActionIcon";

const RoleTable = ({ roles, onEdit, onDelete }) => {
  if (roles.length === 0) {
    return (
      <table style={{ maxWidth: "900px" }}>
        <thead>
          <tr>
            <th>Role Name</th>
            <th>Role Code</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="4" className="p_3">
              No roles found.
            </td>
          </tr>
        </tbody>
      </table>
    );
  }

  return (
    <table style={{ maxWidth: "900px" }}>
      <thead>
        <tr>
          <th>Role Name</th>
          <th>Role Code</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {roles.map((role) => (
          <tr key={role.id}>
            <td className="p_3">{role.name}</td>
            <td className="p_3">{role.role_code}</td>
            <td className="p_3">{role.description}</td>
            <td>
              <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                <ButtonActionIcon type="edit" size="sm" title="Edit Role" onClick={() => onEdit(role)} />
                {/* <ButtonActionIcon
                  type="person_add"
                  size="sm"
                  title="Assign Users"
                  onClick={() => onAssignUsers(role)}
                /> */}
                <ButtonActionIcon
                  type="delete"
                  size="sm"
                  className="danger"
                  title="Delete Role"
                  onClick={() => onDelete(role.id)}
                />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default RoleTable;
